/// <reference path="../../PropertyManagement/Tenants/TenantsDialog.ts" />

namespace SorAraBul.PropertyManagement {

    @Serenity.Decorators.registerClass()
    export class PropertyTenantsDialog extends TenantsDialog {
        constructor() {
            super();

        }

        protected updateInterface() {
            super.updateInterface();

            Serenity.EditorUtils.setReadOnly(this.form.PropertyId, true);
        }
    }
}